import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { assetIds, ThemedAsset } from "nemuru-components";
import React, { useContext } from "react";
import { Controller, useForm } from "react-hook-form";
import { ICON_TITLE_HEIGHT } from "../../../../../config/config";
import { objectTypesConfigToArray } from "../../../../../utils/objectTypesConfigToArray";
import IconTitle from "../../../../shared/components/IconTitle";
import MainButton from "../../../../shared/components/MainButton";
import Text from "../../../../shared/components/Text";
import {
  companyActivitiesTypesConfig,
  employmentStatusTypesConfig,
} from "../config";
import { isValidCIF } from "@nemuru-eng/js-api-client";
import { ConfigContext } from "../../../../../contexts/ConfigContext";
import { THEME_NAMES } from "../../../../../config/themes/config";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import { assetTypes } from "../../../../shared/config";

export const CIF_REQUIRED_EMPLOYMENT_STATUS = [
  employmentStatusTypesConfig.INDEFINITE_EMPLOYED.value,
  employmentStatusTypesConfig.TEMPORARY_EMPLOYED.value,
  employmentStatusTypesConfig.CIVIL_SERVANT.value,
  employmentStatusTypesConfig.TRAINEE.value,
  employmentStatusTypesConfig.CASUALTY_WORKER.value,
];

export default function ProfessionalDataCompanyForm({
  onSubmitForm,
  data,
  employmentStatus,
}) {
  const { palette } = useTheme();
  const {
    state: { themeName },
  } = useContext(ConfigContext);
  const {
    state: { loan },
  } = useContext(ProcessContext);

  const { register, getValues, handleSubmit, errors, control } = useForm({
    defaultValues: {
      companyActivity: data?.companyActivity || "",
      companyName: data?.companyName,
      companyCity: data?.companyCity,
      corporateIdNumber: data?.corporateIdNumber,
    },
  });

  return (
    <>
      <Box className="appear-anim">
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_COMPANY_DATA}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId="PROFESSIONAL_DATA" />}
          subtitle={<Text tId="COMPANY_INFO" />}
        />
        <FormControl fullWidth>
          <InputLabel id="companyActivity">
            <Text tId="COMPANY_ACTIVITY" />
          </InputLabel>
          <Controller
            name="companyActivity"
            control={control}
            rules={{
              required: {
                value: true,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
            }}
            render={(props) => (
              <>
                <Select
                  MenuProps={{
                    MenuListProps: {
                      "aria-label": "Select company activity",
                    },
                  }}
                  onChange={(e) => props.onChange(e.target.value)}
                  value={props.value}
                  error={errors.companyActivity ? true : false}
                >
                  {objectTypesConfigToArray(companyActivitiesTypesConfig).map(
                    (type) => (
                      <MenuItem key={type.value} value={type.value}>
                        {type.display}
                      </MenuItem>
                    )
                  )}
                </Select>
                <FormHelperText style={{ color: palette.error.main }}>
                  {errors.companyActivity?.message}
                </FormHelperText>
              </>
            )}
          />
        </FormControl>
        <TextField
          fullWidth
          label={<Text tId={"COMPANY_NAME"} />}
          type="text"
          id="companyName"
          name="companyName"
          error={errors.companyName ? true : false}
          helperText={errors.companyName?.message}
          inputProps={{
            ref: register({
              required: {
                value: true,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
            }),
          }}
        />
        <TextField
          fullWidth
          label={<Text tId={"COMPANY_CITY"} />}
          type="text"
          id="companyCity"
          name="companyCity"
          error={errors.companyCity ? true : false}
          helperText={errors.companyCity?.message}
          inputProps={{
            ref: register({
              required: {
                value: true,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
            }),
          }}
        />
        {themeName !== THEME_NAMES.caixabank &&
          loan.asset_reference[0].type === assetTypes.AUTO &&
          CIF_REQUIRED_EMPLOYMENT_STATUS.includes(employmentStatus) && (
            <TextField
              fullWidth
              label={<Text tId={"COMPANY_CIF"} />}
              type="text"
              id="corporateIdNumber"
              name="corporateIdNumber"
              error={errors.corporateIdNumber ? true : false}
              helperText={errors.corporateIdNumber?.message}
              inputProps={{
                ref: register({
                  required: {
                    value: true,
                    message: <Text tId={"REQUIRED_FIELD"} />,
                  },
                  validate: (value) => {
                    if (!isValidCIF(value)) {
                      return <Text tId={"NON_VALID_CIF"} />;
                    }
                  },
                }),
              }}
            />
          )}
      </Box>
      <Box>
        <MainButton onClick={handleSubmit(() => onSubmitForm(getValues()))} />
      </Box>
    </>
  );
}
